module.exports = __webpack_public_path__ + "static/img/6.7cf4810f.png";